import styled, { css } from 'styled-components';
import { ButtonTag } from '../../components/Button/styles';

export const CancelingHeading = styled.h2`
  display: flex;
  justify-content: space-between;
  margin: 20px 50px;
  margin-bottom: 25px;
  padding: 0;

  font-size: 20px;
  line-height: 1;

  color: ${({ theme }) => theme.blue};
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Button = styled(ButtonTag)`
  padding: 10px 25px;
  margin-right: 10px;
  width: 80px;

  ${({theme, colorType}) => colorType === 'danger' && css`
    color: ${theme.white};

    background-image: linear-gradient(159.02deg, #2DB9FE 0%, #4EDBFC 100%);
    box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);

    svg {
      fill: ${theme.white};
      stroke: ${theme.white};
    }

    &:hover {
      color: ${theme.red};

      background-image: none;
      box-shadow: inset 0 0 0 2px ${theme.red};

      svg {
        fill: ${theme.red};
        stroke: ${theme.red};
      }
    }
  `}
`;
